<ada-app-shell>
	<ada-admin-portal-header data-container-selector="app-header" />
	<ada-side-nav
		data-container-selector="side-nav"
		[isCollapsed]="appShellService.drawerCollapsed | async"
		[menuController]="menuController"
		[productName]="currentProductName"
		[sections]="sections | async"
	>
		<div
			ada-color="foreground"
			data-container-selector="ada-sidenav-footer"
		>
			<p>
				{{ copyrightMessage | async }}
			</p>
			<p>
				Version:
				<code
					ada-background-color="background-3"
					class="ada-overflow-hidden"
					style="max-width: 100%; text-overflow: ellipsis; vertical-align: middle"
				>
					{{ env.build() }}
				</code>
			</p>
			<p>
				Revision:
				<code
					ada-background-color="background-3"
					class="ada-overflow-hidden"
					style="max-width: 100%; text-overflow: ellipsis; vertical-align: middle"
				>
					{{ env.hash() }}
				</code>
			</p>
		</div>
	</ada-side-nav>
	<app-admin-portal-body data-container-selector="app-body" />
</ada-app-shell>
<div
	#ChartTooltipContainer
	class="ada-zindex-10"
	popover="hint"
></div>
